// extracted by mini-css-extract-plugin
export var actionButton = "_gn-0";
export var fileInput = "_gn-2";
export var paperclip = "_gn-1";